import React from 'react';
import './SearchBar.css';

const SearchBar = ({
  placeholder = "Search...",
  value,
  onChange,
  className = "",
  showIcon = true
}) => {
  const handleReset = () => {
    if (onChange) {
      // Create a synthetic event to clear the input
      const event = {
        target: {
          value: ''
        }
      };
      onChange(event);
    }
  };

  return (
    <div className={`search-bar-container ${className}`}>
      {showIcon && (
        <svg
          className="search-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
      )}
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="search-input"
      />
      {value && value.length > 0 && (
        <button
          type="button"
          className="search-reset-button"
          onClick={handleReset}
          aria-label="Reset search input"
        >
          &#x2715;
        </button>
      )}
    </div>
  );
};

export default SearchBar;
